// Mirror of Doc.ECM.DomainModel/Const/SecurityRelevantFiles.cs - both files must move together.
// The server is always the authority; these lists only give faster feedback in the UI.
// Documents are allowed by the SupportedFileFormats parameter, but these extensions are always
// rejected, even when the parameter lists them.
const SecurityRelevantFiles = {
    NotAllowedExtensionList: [
        // Executables and libraries
        '.exe', '.dll', '.msi', '.com', '.scr', '.cpl', '.jar', '.lnk', '.reg',
        // Scripts
        '.js', '.json', '.ps1', '.bat', '.cmd', '.sh', '.vbs', '.vbe', '.jse',
        '.wsf', '.wsh', '.hta', '.cgi', '.pl', '.py', '.rb',
        // Server side pages executable by IIS / PHP / Java
        '.aspx', '.asp', '.asax', '.ashx', '.asmx', '.cshtml', '.vbhtml', '.config',
        '.cs', '.vb', '.php', '.php3', '.php4', '.php5', '.phtml', '.shtml',
        '.jsp', '.jspx',
        // Other extensions IIS maps to a handler
        '.svc', '.axd', '.rem', '.soap', '.xamlx', '.ascx', '.master', '.asa', '.cdx',
        '.shtm', '.stm',
        // Disk images
        '.iso', '.img', '.vhd'
    ]
};

export default SecurityRelevantFiles;
